import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'

import { LOCALE_PREFIX } from './constants'

import hocOnChange from '../HocOnChange'

import './style.scss'

@hocOnChange
export default class ButtonsControls extends Component {
    static propTypes = {
        moduleName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    }

    static defaultProps = {
        onChange: () => {},
    }

    handleBtnClick = (showBlocks) => {
        const { moduleName, name, onChange } = this.props

        onChange(moduleName, name, showBlocks)
    }

    render() {
        return (
            <div className={'ribbon-buttons-controls'}>
                <Tooltip
                    id={'report-ribbon-controls-tooltip-show-all'}
                    content={<FormattedMessage id={`${LOCALE_PREFIX}.showAllTooltip`} />}
                    width={'230px'}
                    align={ALIGN.CENTER}
                    position={POSITION.BOTTOM}
                    doubleWrap
                >
                    <button className={'ribbon-btn-control show-all'} onClick={() => this.handleBtnClick(true)}>
                        <div className={'icon'} />
                        <div className={'text-wrapper'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.showAllBlocks`} values={{ break: <br /> }} />
                        </div>
                    </button>
                </Tooltip>
                <Tooltip
                    id={'report-ribbon-controls-tooltip-hide-all'}
                    content={<FormattedMessage id={`${LOCALE_PREFIX}.hideAllTooltip`} />}
                    width={'230px'}
                    align={ALIGN.CENTER}
                    position={POSITION.BOTTOM}
                    doubleWrap
                >
                    <button className={'ribbon-btn-control hide-all'} onClick={() => this.handleBtnClick(false)}>
                        <div className={'icon'} />
                        <div className={'text-wrapper'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.hideAllBlocks`} values={{ break: <br /> }} />
                        </div>
                    </button>
                </Tooltip>
            </div>
        )
    }
}
